import { githubAppApi, holdInstallFlow } from '../api/githubApp'

/** Send the browser to the central GitHub App's install page, holding the
 * flow state for the installed page's claim. With `reconnect`, the claim
 * re-binds that disconnected connection instead of creating a new one. */
export async function startCentralInstall(
  workspaceId: string,
  reconnect?: string,
): Promise<void> {
  const flow = reconnect
    ? await githubAppApi.startInstallFlow(workspaceId, reconnect)
    : await githubAppApi.startInstallFlow(workspaceId)
  holdInstallFlow({
    state: flow.state,
    workspaceId,
  })
  window.location.assign(flow.install_url)
}
